import React from "react"
import { Link } from 'gatsby'
import {
  DropDown,
  DropDownList,
  DropDownListItem,
} from './dropdown'


function ResourcesDropdown({ isActive }) {
  return (
    <DropDown className={`dropdown-menu ${isActive ? 'active' : ''}`}>
        <DropDownList>
        {
            [
              {
                  title: 'About Us',
                  link: '/about-us',
              },
              {
                  title: 'Color Options',
                  link: '/color-options',
              },
              {
                  title: 'Building FAQs',
                  link: '/faqs',
              },
              {
                  title: 'Ordering Process',
                  link: '/ordering-process',
              },
              {
                  title: 'Site Preparation',
                  link: '/site-preparation',
              },
              {
                title: 'Snow and Wind Loads',
                link: '/snow-and-wind-load',
              },
              {
                title: 'RTO',
                link: '/rent-to-own-metal-buildings',
              },
              {
                title: 'Financing',
                link: '/financing',
              },
            ].map((item, i) => (
                <DropDownListItem key={i}>
                    <Link to={item.link}>{item.title}</Link>
                </DropDownListItem>
            ))}
        </DropDownList>
    </DropDown>
  )
}

export default ResourcesDropdown